import { FIO, NAME_ORGANITHATION } from '@/remotes';
import { useDataFormStore } from '@/stores/form';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';

export function getArrayOfRules(rule, ruleName) {
  return [...Object.keys(rule)].map((item) => `${ruleName}.${item}`);
}

export async function getNameOrganization(who, query) {
  const dataForm = useDataFormStore();
  try {
    const { data } = await NAME_ORGANITHATION.post('4_1/rs/findById/party', {
      query,
    });
    const nameOrganithation = data.suggestions[0].data.name.short_with_opf;
    dataForm[who].name = checkNameOrganization(nameOrganithation);
  } catch (e) {
    return;
  }
}

export async function getNewCargoPickUpNameOrganization(who, query) {
  const dataForm = useNewDataFormCargoPickUpStore();
  try {
    const { data } = await NAME_ORGANITHATION.post('4_1/rs/findById/party', {
      query,
    });
    const nameOrganithation = data.suggestions[0].data.name.short_with_opf;
    dataForm[who].name = checkNameOrganization(nameOrganithation);
  } catch (e) {
    return;
  }
}

export async function getSuggestedInnAndOrganizations(query) {
  try {
    const { data } = await NAME_ORGANITHATION.post('/4_1/rs/suggest/party', {
      query,
    });

    const suggestedOrganizations = data.suggestions.reduce((acc, { data }) => {
      const title = checkNameOrganization(data.name.short_with_opf);
      const { inn } = data;

      if (title) {
        acc.push({ title, inn });
      }
      return acc;
    }, []);

    return suggestedOrganizations;
  } catch (e) {
    return [];
  }
}

export async function getSuggestedFio(query) {
  try {
    const { data } = await FIO.post('/4_1/rs/suggest/fio', {
      query,
    });

    const suggestedFio = data.suggestions.reduce((acc, { value }) => {
      acc.push(value);

      return acc;
    }, []);

    return suggestedFio;
  } catch (e) {
    return [];
  }
}

function checkNameOrganization(name) {
  return name?.replace(/НАО/g, 'ЗАО');
}
